export type createFileType = {
  file: File;
};

const createFile = (fileName: string | undefined): createFileType => {
  return {
    file: new File([''], fileName || '', { type: 'image/jpeg' }),
  };
};

export default createFile;
